import React from "react"
import { Link } from "react-router-dom"
import { Helmet } from "react-helmet"

const NotFound = () => (
  <div className="container">
    <Helmet>
      <title>404 Page Not Found</title>
    </Helmet>
    <h1 style={{ fontSize: 50 }}>404 Page Not Found</h1>
    <p style={{ fontSize: 25 }}>
      Sorry, the page you&apos;re looking for doesn&apos;t exist. Here are some
      links that might be useful though:
    </p>
    <ul>
      <li>
        <Link to="/courses">Enroll in our Online Drivers Ed Course</Link>
      </li>
      <li>
        <Link to="/book">See availability for driving lessons</Link>
      </li>
      <li>
        <Link to="/pricing">See all our prices for your address</Link>
      </li>
      <li>
        <Link to="/">
          See all of our products and services by visiting our home page
        </Link>
      </li>
    </ul>
    <div style={{ textAlign: "center", marginTop: 100 }}>
      <img
        src="https://res.cloudinary.com/coastline-academy/image/upload/c_scale,q_auto,w_400/v1587161099/misc-images/404-towing_ffvyn0.png"
        alt="Coastline 404 Page"
      />
    </div>
  </div>
)

export default NotFound
